import React from "react";

import InputMask from "react-input-mask";

const MaskInput = ({ field, form, ...props }) => {
  const handleChange = (e) => {
    const value = e.target.value;

    const parts = value.split("/");
    if (parts[2] === "____") {
      form.setFieldValue(field.name, parts[0] + "/" + parts[1]);
    } else {
      form.setFieldValue(field.name, value);
    }
  };

  return <InputMask {...props} value={field.value} onChange={handleChange} />;
};

export default MaskInput;
